import React, {useEffect, useState} from 'react'
import {Header} from './Header'
import {LogoutPopup} from './NewComponents/LogoutPopup'
import {IngresoPromocionHeader} from './NewComponents/IngresoPromocionHeader'
import {LegendColumnRight} from './NewComponents/LegendColumnRight'
import {IngresoCard} from './NewComponents/IngresoCard'

import {BixialLineChart} from './NewComponents/BixialLineChart'
import {ScatterChartComponent} from './NewComponents/ScatterChartComponent'
import {StackedChartComponent} from './NewComponents/StackedChartComponent'
export const IngresoPromocionResumen = () => {
	const [LogoutState, setLogoutState] = useState(false)
	const [HeightState, setHeight] = useState(0)
	const [HeighRight, setHeighRight] = useState(0)

	const HandleResizeWork = () => {
		const WindowHeight = window.innerHeight - 130
		const WindowHeightRight = window.innerHeight - 128
		setHeight(WindowHeight)
		setHeighRight(WindowHeightRight)
	}
	useEffect(() => {
		window.addEventListener('resize', HandleResizeWork)
		HandleResizeWork()
	}, [])

	return (
		<div className='HomeNew'>
			{LogoutState && <LogoutPopup setLogoutState={setLogoutState} />}

			<Header setLogoutState={setLogoutState} />

			{/* header done */}
			<IngresoPromocionHeader />

			<div
				className='body-area-ingreso body-area-ingreso-resumen'
				style={{height: `${HeightState}px`}}
			>
				<div className='left-area'>
					<div className='top-area-ingreso'>
						<p>ROI</p>
						<div className='top'>
							<svg
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<circle cx='8' cy='8' r='7.5' fill='#BDE9E8' stroke='#29BAB8' />
							</svg>
							+5%
						</div>
						<div className='top'>
							<svg
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<circle cx='8' cy='8' r='7.5' fill='#FEE6C1' stroke='#FFAC23' />
							</svg>
							-5 al +5%
						</div>
						<div className='top'>
							<svg
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<circle cx='8' cy='8' r='7.5' fill='#FFCBC2' stroke='#FF5334' />
							</svg>
							-5%
						</div>
						<div className='top'>
							<svg
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<circle cx='8' cy='8' r='7.5' fill='#FAFAFA' stroke='#C7C7C7' />
							</svg>
							Sin ROI
						</div>
					</div>
					<div className='grid-wrapper-card ingreso'>
						<IngresoCard fontColor='#29BAB8' bgColor='#E1FAFA' />
						<IngresoCard fontColor='#FFAC23' bgColor='#FFF6E8' />
						<IngresoCard fontColor='#29BAB8' bgColor='#E1FAFA' />
						<IngresoCard
							fontColor='#FF5334'
							bgColor='#FFE9E5'
							error
							error3
							error2
						/>
						<IngresoCard fontColor='#29BAB8' bgColor='#E1FAFA' />
						<IngresoCard fontColor='#FF5334' bgColor='#FFE9E5' error error1 />
						<IngresoCard fontColor='#29BAB8' bgColor='#E1FAFA' />
						<IngresoCard
							fontColor='#FF5334'
							bgColor='#FFE9E5'
							error
							error3
							error2
						/>
						<IngresoCard fontColor='#FFAC23' bgColor='#FFF6E8' />
					</div>
				</div>

				<div className='right-side'>
					<div className='top-area'>
						<h1>Simulación</h1>
						<span className='badge'>
							<svg
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<g clipPath='url(#clip0_778_87586)'>
									<mask
										id='mask0_778_87586'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='16'
										height='16'
									>
										<rect width='16' height='16' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_778_87586)'>
										<path
											d='M9.64922 10.6666C9.78255 10.8 9.94655 10.8666 10.1412 10.8666C10.3354 10.8666 10.5048 10.7944 10.6492 10.65C10.7826 10.5166 10.8492 10.3471 10.8492 10.1413C10.8492 9.93595 10.7826 9.76662 10.6492 9.63328L8.73255 7.69995V5.39995C8.73255 5.18884 8.66322 5.01662 8.52455 4.88328C8.38544 4.74995 8.21033 4.68328 7.99922 4.68328C7.78811 4.68328 7.61322 4.75262 7.47455 4.89128C7.33544 5.0304 7.26589 5.20551 7.26589 5.41662V7.96662C7.26589 8.06662 7.28544 8.16373 7.32455 8.25795C7.36322 8.35262 7.42144 8.43884 7.49922 8.51662L9.64922 10.6666ZM7.99922 14.8C7.05477 14.8 6.16855 14.6222 5.34055 14.2666C4.513 13.9111 3.79366 13.4277 3.18255 12.8166C2.57144 12.2055 2.08811 11.4862 1.73255 10.6586C1.377 9.83062 1.19922 8.9444 1.19922 7.99995C1.19922 7.05551 1.377 6.16928 1.73255 5.34128C2.08811 4.51373 2.57144 3.7944 3.18255 3.18328C3.79366 2.57217 4.513 2.08884 5.34055 1.73328C6.16855 1.37773 7.05477 1.19995 7.99922 1.19995C8.94366 1.19995 9.82989 1.37773 10.6579 1.73328C11.4854 2.08884 12.2048 2.57217 12.8159 3.18328C13.427 3.7944 13.9103 4.51373 14.2659 5.34128C14.6214 6.16928 14.7992 7.05551 14.7992 7.99995C14.7992 8.9444 14.6214 9.83062 14.2659 10.6586C13.9103 11.4862 13.427 12.2055 12.8159 12.8166C12.2048 13.4277 11.4854 13.9111 10.6579 14.2666C9.82989 14.6222 8.94366 14.8 7.99922 14.8ZM7.99922 13.2833C9.46589 13.2833 10.7132 12.7695 11.7412 11.742C12.7688 10.714 13.2826 9.46662 13.2826 7.99995C13.2826 6.53328 12.7688 5.28595 11.7412 4.25795C10.7132 3.2304 9.46589 2.71662 7.99922 2.71662C6.53255 2.71662 5.28544 3.2304 4.25789 4.25795C3.22989 5.28595 2.71589 6.53328 2.71589 7.99995C2.71589 9.46662 3.22989 10.714 4.25789 11.742C5.28544 12.7695 6.53255 13.2833 7.99922 13.2833Z'
											fill='#949494'
										/>
									</g>
								</g>
								<defs>
									<clipPath id='clip0_778_87586'>
										<rect width='16' height='16' fill='white' />
									</clipPath>
								</defs>
							</svg>

							<p>17:45 | 30/12/22</p>
						</span>
					</div>

					<div className='bottom-chart-area'>
						<div>
							<BixialLineChart />
							{/* <img src={secondChart} alt='' /> */}
						</div>
						<div>
							<ScatterChartComponent />
							{/* <img src={firstChart} alt='' /> */}
						</div>
						<div>
							<StackedChartComponent />
							{/* <img src={thirdChart} alt='' /> */}
						</div>
					</div>
				</div>
				<LegendColumnRight secondActive HeightStateRight={HeighRight} />
			</div>
		</div>
	)
}
